module.exports = __webpack_public_path__ + "img/io.39b944ce.svg";